export default __webpack_public_path__ + "maps-examples-clustering-with-images-thumbnail-960-6d96e0a9d73a67e5c59b4c7aaf7e9544.png";